<template>
  <v-main class="centered-layout">
    <v-container fluid align-center fill-height justify-center>
      <slot></slot>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'CenteredLayout'
}
</script>
